<template>
    <div class="pencil-icon">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.753885 10.6907L0 13.4974L2.84496 12.7592L13.5709 2.07049L11.4808 0L0.753885 10.6907Z" fill="white"/>
        </svg>
    </div>
</template>

<script>
export default {
    name: "PencilIcon"
}
</script>

<style scoped lang="scss">
:root {
    --event-pencil-icon-background-color: rgba(17, 13, 13, 0.4);
}
.pencil-icon {
    background: linear-gradient(141.5deg, var(--event-pencil-icon-background-color, rgba(17, 13, 13, 0.4)) -156.59%, rgba(255, 255, 255, 0) 209.06%);
    filter: drop-shadow(0px 0px 35px rgba(0, 0, 0, 0.2));
    backdrop-filter: blur(120px);
    border-radius: 4px;
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>